import { Alert, Form, Space, Typography, Button } from 'antd'
import React, { forwardRef, useEffect, useCallback } from 'react'
import AuthorisedContainer from 'components/AuthorisedContainer'
import { FieldTypes, generateFormFields } from 'utils/formUtils'
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import { isUndefined } from 'lodash'
import { CheckmarxOneScanFiltersAPI } from 'restAPI/ToolsIntegrationAPI'
import { PermissionSetMap } from 'constants/RBACConstants'

const CheckmarxOneScanFilters = forwardRef(({toolName, handleValidationError},ref) => {
    const [form] = Form.useForm();
    const { globalFilterHash } = useGlobalFilterContext();

    useEffect(() => {
        const {cancel, promise} = CheckmarxOneScanFiltersAPI.getConfiguredScanFilters();
        promise.then((resData) => {
            if(!isUndefined(resData)) {
                form.setFieldsValue(
                    {
                        branches : resData?.config?.branches === "" ? null : resData?.config?.branches,
                        initiators : resData?.config?.initiators === "" ? null : resData?.config?.initiators,
                    },
                )
            }
        })
        return cancel;
    }, [globalFilterHash, form]);

    const isValidInput = (filter, value) => {
        if(value === "") return true;
        if(filter.field === "branches") {
            const branchRegex = /^[a-zA-Z0-9/._-]+$/;
            const branches = value.split(",");
            return branches.every((v) => (v !== "" && branchRegex.test(v)));
        } else if(filter.field === "initiators") {
            const initiators = value.split(",");
            return initiators.every((v) => (v !== "" && v === v.trim()))
        }
        return true;
    }

    const requiredValidation = () => {
      return {
        validator: (field, value) => {
          if (!isValidInput(field, String(value))) {
            handleValidationError(true);
            return Promise.reject(<>Invalid {field.field} filter value</>);
          } else {
            handleValidationError(false);
            return Promise.resolve();
          }
        }
      }
    }

    const onReset = useCallback(async() => {
        form.setFieldsValue({branches:null, initiators:null});
    },[form,]);

    const fields = [
        {
            name: "branches",
            placeholder: "branches",
            type: FieldTypes.ANTD_DEFAULT_INPUT,
            rules: [requiredValidation],
            label: "Branches",
            help: "Filter scan results by the names of the Git branches scanned. You can enter multiple values, separated by commas with no leading or trailing white spaces. Please note, this field is case-sensitive."
        },
        {
            name: "initiators",
            placeholder: "initiators",
            type: FieldTypes.ANTD_DEFAULT_INPUT,
            rules: [requiredValidation],
            label: "Initiators",     
            help: "Filter scan results by the identifier of the user who initiated the scan. You can enter multiple values, separated by commas with no leading or trailing white spaces. This field is case-sensitive. \nIf no scans are found for the given initiator, the latest scan from other initiators will be ingested instead."
        },
    ];

    return ( 
        <Space direction="vertical" className="m-b-m">
            <Typography.Text style={{ width: "100%", marginBottom: 16 }}>Checkmarx One scan filters</Typography.Text>
            <Alert
                description={
                    <Form
                        form={form}
                        ref={ref}
                        style={{ width: "30vw" }}
                        layout="vertical"
                    >
                        {generateFormFields(fields)}

                        <Form.Item className="text-right p-x-sm" >
                            <AuthorisedContainer permission={PermissionSetMap.UPDATE_SLA}>
                                <Button type="primary" onClick={onReset}>Reset</Button>
                            </AuthorisedContainer>
                         </Form.Item>  
                    </Form>
                }
                />
        </Space>
         
    )
})

export default CheckmarxOneScanFilters;
